function isBetween(value, min, max) {
	return min <= value && value <= max;
}
function isEmpty(value) {
	return value === '';
}
function notEmpty(value) {
	return !this.isEmpty(value);
}
function onlyDigits(value) {
	const onlyDigits = /^\d+$/;
	return onlyDigits.test(value);
}
function isGreater(value, max) {
	return value > max;
}

export {
	isBetween,
	isEmpty,
	notEmpty,
	onlyDigits,
	isGreater
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/withdraw/validators.js